import * as React from "react";
import { inject, observer } from "mobx-react";

import FSStore from "../../entryes/panel/Filestorage/store";
import FSPopupNoticeStore from "./store";
import { IPopupNotice } from "../../entryes/panel/Filestorage/types";

interface IProps {
  fsStore?: FSStore;
  fsPopupNoticeStore?: FSPopupNoticeStore;
}

@inject("fsStore", "fsPopupNoticeStore")
@observer
export class PopupNotice extends React.Component<IProps> {
  private fsStore = this.props.fsStore;
  private fsPopupStore = this.props.fsPopupNoticeStore;

  render() {
    const popups = this.fsPopupStore.getPopups;

    return (
      <div id="react-popup-notices">
        {popups.map((item: IPopupNotice, idx: number) => {
          let { message, classes, isOnHide } = item;
          classes += isOnHide ? ` popup-notice_hiding` : ``;
          return (
            <div
              key={`popup-${item.id}`}
              className={`popup-notice ${classes} popup-notice_position-${idx}`}
            >
              {message}
            </div>
          );
        })}
      </div>
    );
  }
}
